import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"

import ButtonComponent from "../../../../../Components/Button"
import EstimatedProgramStatusTable from "./Table/EstimatedProgramStatusTable"

import "./EstimatedProgramStatus.less"

const { Text } = Typography

const EstimatedProgramStatus = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { isMobile } = useSelector((state) => state.nav)

  const handleViewAll = () => {
    navigate("estimated_program_status")
  }

  return (
    <div className="estimated-program-status-wrap">
      <div className="estimated-program-status">
        <Flex className="header" align="flex-start" justify="space-between" gap={10}>
          <Text>Estimated program status</Text>
          {!isMobile && <ButtonComponent onClick={handleViewAll}>{t("View All")}</ButtonComponent>}
        </Flex>

        <EstimatedProgramStatusTable variant="block" pageSize={5} />
      </div>

      {isMobile && (
        <ButtonComponent
          // className="estimated-program-status-view-all-btn"
          style={{ width: "100%", marginTop: 16, height: 40 }}
          onClick={handleViewAll}
        >
          {t("View All")}
        </ButtonComponent>
      )}
    </div>
  )
}

export default EstimatedProgramStatus
